/** Vorbelegter Abrufzeitraum in Tagen ab heute. */
export const DEFAULT_RANGE_IN_DAYS = 30;

/** Der Stundenplan reicht zusätzlich so weit zurück — für den Klassenbuch-Nachtrag. */
export const PAST_DAYS_IN_RANGE = 3;

/** Der Meetingname hat keine eigene Spalte, er steht als Tooltip an der Zeile. */
export function meetingNameTooltip(row: { meetingName?: string }): string {
  return row.meetingName ?? 'Kein Meeting-Link vorhanden';
}
